module.exports = __webpack_public_path__ + "img/hr-red-pita-13.1c9728db.png";